<template>
  <van-popup
    v-model="showPopup"
    class="pay-type-popup"
    position="bottom"
  >
    <div class="pay-type-popup-wrap">
      <div class="pay-type-popup-title">
        请选择支付方式
        <img
          class="close-btn"
          src="@/assets/img/chargingVoucher/icon-bottom-popup-close.png"
          alt=""
          @click="showPopup = false"
        >
      </div>
      <div class="pay-type-popup-content">
        <div class="pay-type-popup-options">
          <van-radio-group v-model="radio">
            <div
              v-if="canUseScore"
              class="pay-type-popup-option"
              :class="{
                'disabled': !canScorePay
              }"
              @click="() => handleRadioClick('SCORE_PAY')"
            >
              <div class="pay-type-popup-option-left">
                <img
                  class="pay-type-option-icon"
                  src="@/assets/img/chargingVoucher/icon-score-pay.png"
                  alt=""
                >
                积分支付
                <span
                  class="pay-type-option-sub-title"
                >（{{ canUseScore }}积分可用）</span>
              </div>
              <div class="pay-type-popup-option-right">
                <van-radio
                  name="SCORE_PAY"
                  checked-color="#FE7256"
                />
              </div>
            </div>
            <div
              class="pay-type-popup-option"
              @click="() => handleRadioClick('WECHAT_PAY')"
            >
              <div class="pay-type-popup-option-left">
                <img
                  class="pay-type-option-icon"
                  src="@/assets/img/chargingVoucher/icon-wx-pay.png"
                  alt=""
                >
                微信支付
              </div>
              <div class="pay-type-popup-option-right">
                <van-radio
                  name="WECHAT_PAY"
                  checked-color="#FE7256"
                />
              </div>
            </div>
          </van-radio-group>
        </div>
        <div class="pay-btn-wrap">
          <div
            class="pay-btn"
            @click="handleToPay"
          >
            {{ needPayNumber }} 立即支付
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'PayTypePopup',
  props: {
    canUseScore: {
      type: [String, Number],
      default: 0
    },
    payValue: {
      type: [String, Number],
      default: 0
    },
    payScore: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      showPopup: false,
      radio: 'WECHAT_PAY'
    };
  },
  computed: {
    needPayNumber() {
      if (this.radio === 'SCORE_PAY') {
        return `${this.payScore} 积分`;
      } else if (this.radio === 'WECHAT_PAY') {
        return `￥${this.payValue} 元`;
      }
      return '';
    },
    canScorePay() {
      return this.canUseScore >= Number(this.payScore);
    }
  },
  methods: {
    openPopup() {
      this.showPopup = true;
      if (this.canScorePay) {
        this.radio = 'SCORE_PAY';
      } else {
        this.radio = 'WECHAT_PAY';
      }

      this.$emit('open');
    },
    closePopup() {
      this.showPopup = false;
      this.$emit('close');
    },
    handleToPay() {
      if (this.radio === 'SCORE_PAY' && !this.canScorePay) {
        this.$toast({
          message: '您的积分不足，暂无法支付。',
          duration: 2000
        });
        return;
      }
      this.$emit('confirm', this.radio);
    },
    handleRadioClick(type) {
      if (type === 'SCORE_PAY' && !this.canScorePay) {
        this.$toast({
          message: '您当前的积分不足',
          duration: 2000
        });
        return;
      }
      this.radio = type;
    }
  }
};
</script>

<style lang="scss" scoped>
.pay-type-popup {
  .pay-type-popup-wrap {
    background: #ffffff;
    border-radius: 20px 20px 0px 0px;
    box-sizing: border-box;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;

    .pay-type-popup-title {
      font-size: 32px;
      color: #383838;
      text-align: center;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #e6e6e6;
      height: 116px;
      position: relative;
      flex-shrink: 0;

      .close-btn {
        width: 40px;
        height: 40px;
        position: absolute;
        right: 32px;
        object-fit: contain;
      }
    }
    .pay-type-popup-content {
      font-size: 32px;
      color: #646464;
      letter-spacing: -1.48px;
      font-weight: 400;
      box-sizing: border-box;
      width: 100%;
      overflow: scroll;
      line-height: 45px;
      flex: 1;
      padding-bottom: calc(
        32px + constant(safe-area-inset-bottom)
      ); /* 兼容 i0S<11.2 */
      padding-bottom: calc(
        32px + env(safe-area-inset-bottom)
      ); /* 兼容10S>= 11.2 */

      .pay-type-popup-options {
        box-sizing: border-box;
        padding: 0px 48px;

        .pay-type-popup-option {
          height: 150px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 32px;
          color: #383838;
          font-weight: 400;

          .pay-type-popup-option-left {
            display: flex;
            align-items: center;
          }
          .pay-type-option-icon {
            width: 60px;
            height: 60px;
            margin-right: 24px;
            object-fit: contain;
          }
          .pay-type-option-sub-title {
            font-size: 24px;
            color: #fe7256;
            font-weight: 400;
          }
          &.disabled {
            filter: grayscale(100%);
          }
        }
      }
      .pay-btn-wrap {
        height: 186px;
        display: flex;
        align-items: center;
        justify-content: center;

        .pay-btn {
          background: #fe7256;
          border-radius: 20px;
          font-size: 32px;
          color: #ffffff;
          font-weight: 400;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 90px;
          width: 654px;
        }
      }
    }
  }
}
.van-popup {
  background-color: unset;
}
</style>
